import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { LookInside } from './components/LookInside';
import { BonusSection } from './components/BonusSection';
import { ChangeSection } from './components/ChangeSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
export function App() {
  useEffect(() => {
    const pixelWindow = window as PixelWindow;
    try {
      if (!pixelWindow.fbq) {
        const fbq = ((...args: unknown[]) => {
          if (fbq.callMethod) {
            fbq.callMethod(...args);
          } else {
            fbq.queue?.push(args);
          }
        }) as PixelFunction;
        pixelWindow.fbq = fbq;
        if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript?.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          document.head.appendChild(script);
        }
      }
      pixelWindow.fbq?.('init', '1005118822521193');
      pixelWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3uevsk1fpcc45">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1005118822521193&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="d4nwrk0ubq3z" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-white text-brand-ink" data-id="element-2" data-mp="83i3nl39q0tx">
        <PurchasePopup data-id="element-3" data-mp="3glwfs77b0w0a" />
        <main data-id="element-4" data-mp="3gj1rg4l66r1l">
          <Hero data-id="element-5" data-mp="3bmjqlfsyncuj" />
          <PainSection data-id="element-6" data-mp="3bn2xm1h2ogts" />
          <SystemSection data-id="element-7" data-mp="3bnmedeuzkz68" />
          <LookInside data-id="element-8" data-mp="3bk71miosc27z" />
          <BonusSection data-id="element-9" data-mp="3qaxrhl6tgr8g" />
          <ChangeSection data-id="element-10" data-mp="3qbfur1rwc5pv" />
          <PricingCard data-id="element-11" data-mp="3qcqy50hfjbgg" />
          <Guarantee data-id="element-12" data-mp="3qd0s0z5li2rf" />
          <Testimonials data-id="element-13" data-mp="3lkr41oo1jcrs" />
          <FAQ data-id="element-14" data-mp="3ljg1tta8ud2s" />
          <FinalCTA data-id="element-15" data-mp="3liwjibgolmo8" />
        </main>
        <Footer data-id="element-16" data-mp="3limqsg4951eu" />
      </div>
    </>;
}